import { Dropdown, Menu, MenuButton, MenuItem } from '@mui/base'
import { clsx } from 'clsx'
import { type FC } from 'react'

import { CustomerDataControllerApiFactory } from '@redteclab/api/clients/bully'
import { IconCaretDown, IconCheck } from '@redteclab/icons'

import { useBullyApi } from '../../../../base-api-communication'
import { useGlobalConfigContext } from '../../../../global-config'
import { useUserApiSwrSessionV1Customer } from '../../../../user-data'
import { useAlternativeUrlsContext } from '../../../alternativeUrls'

export const LanguageSwitcherSelect: FC = () => {
  const { language, tenantAndEnv } = useGlobalConfigContext()
  const alternateLanguages = useAlternativeUrlsContext()
  const { data: userData } = useUserApiSwrSessionV1Customer()
  const customerDateServiceClient = useBullyApi(
    CustomerDataControllerApiFactory,
  )
  const supportedLanguages = Object.keys(alternateLanguages)

  const updateCustomerPreferredLanguage = (newLanguage: string): void => {
    if (userData?.customerNumber) {
      customerDateServiceClient
        .customerV1TenantPreferredLanguagePatch({
          CustomerDataPreferredLanguage: { preferredLanguage: newLanguage },
          tenant: tenantAndEnv,
        })
        .catch(() => {
          // do nothing
        })
    }
  }

  if (supportedLanguages.length <= 1) {
    return null
  }

  return (
    <Dropdown>
      <MenuButton className="flex items-center whitespace-nowrap text-xs leading-none hover:text-dark-brand">
        {alternateLanguages[language].translatedLanguage}{' '}
        <IconCaretDown className="ml-1" />
      </MenuButton>
      <Menu
        className="z-50"
        slotProps={{
          listbox: {
            className:
              'min-w-40 overflow-hidden rounded-2xl bg-light-primary-low font-medium shadow-m',
          },
        }}
      >
        {supportedLanguages.map((languageCode) => (
          <MenuItem className="focus:outline-none" key={languageCode}>
            <a
              className={clsx(
                'flex w-full items-center py-3 pl-6 pr-4 hover:bg-light-primary-medium focus:outline focus:outline-2 focus:outline-offset-[-6px]',
                language === languageCode && 'bg-light-primary-medium',
              )}
              data-lang={languageCode}
              href={alternateLanguages[languageCode].path}
              onClick={() => {
                updateCustomerPreferredLanguage(languageCode)
              }}
              role="menuitem"
            >
              {alternateLanguages[languageCode].translatedLanguage}
              {language === languageCode && (
                <IconCheck className="ml-auto text-xl" />
              )}
            </a>
          </MenuItem>
        ))}
      </Menu>
    </Dropdown>
  )
}
